<template>
	<div class="sa-list-component">
		<div class="sa-list-component-header">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table :selectable="selectable" selectMode="single" sticky-header ref="table" stacked="lg" striped
					hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey"
					sort-icon-left head-variant="light" class="sa-b-table" @row-selected="onRowSelected">
					<template #cell(index)="row">
						{{ row.index + 1 }}
					</template>
					<template v-slot:cell(updateDate)="{ item }">
						{{ formatDateTime(item.updateDate) }}
					</template>
					<template #cell(actions)="{ item }">
						<b-container v-if="!selectable" class="btn-table-action-section">
							<b-button size="sm" variant="outline-primary outline-primary-noborder pull-right"
								v-b-tooltip.hover title="Associa Profili" @click="onClickAssociaProfili(item)">
								<b-icon icon="people-fill"></b-icon>
							</b-button>
							<b-button size="sm" variant="outline-purple outline-purple-noborder pull-right"
								v-b-tooltip.hover title="Visualizza Preview" @click="onClickPreview(item)">
								<i class="far fa-file-pdf"></i>
							</b-button>

							<b-button size="sm" v-b-tooltip.hover title="Modifica Consenso"
								variant="outline-success outline-secondary-noborder pull-right"
								@click="onClickEdit(item)">
								<font-awesome-icon icon="edit"> </font-awesome-icon>
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
		<ConsensiPreviewModalComponent ref="mdlPreviewConsensi" />
		<ConsensiProfiliListModalComponent ref="mdlConsensiProfiliListModalComponent" />
	</div>
</template>

<script>
import ConsensiProfiliListModalComponent from "./ConsensiProfiliListModalComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ConsensiPreviewModalComponent from "./ConsensiPreviewModalComponent.vue";
export default {
	props: {
		selectable: { type: Boolean, default: false },
	},
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	mixins: [UtilityMixin],
	components: { ConsensiPreviewModalComponent, ConsensiProfiliListModalComponent },
	watch: {
		currentPage() {
			let me = this;
			me.loadData();
		},
	},
	data() {
		return {
			rows: 0,
			perPage: 50,
			currentPage: 1,
			pathResource: "/consensi",
			filtro: {},
			items: [],
			sezione: "",
			listKey: 0,
			fields: [
				{
					label: "",
					key: "index",
					sortable: false,
					thStyle: "width: 2rem",
				},
				{
					label: "Nome",
					key: "nomeConsenso",
					sortable: true,
					//thStyle: "width: 7rem",
				},
				{
					label: "Data Ultima Modifica",
					key: "updateDate",
					sortable: true,
					thStyle: "width: 16rem",
				},
				{
					label: "Tipologia",
					key: "tipologia",
					sortable: true,
					thStyle: "width: 7rem",
				},
				{
					label: "",
					class: "sa-table-column-action-double",
					key: "actions",
				},
			],
		};
	},
	// mounted() {
	//     let me = this;
	//     me.loadData();
	// },
	methods: {
		init(filtro, pathResource) {
			let me = this;
			me.filtro = filtro;
			console.log(filtro);

			if (pathResource) {
				this.pathResource = pathResource;
			}
			if (filtro["sezione"]) {
				this.sezione = filtro["sezione"];
			}
			me.loadData();
		},
		openModalNuovoCosenso() {
			this.$router.push("/consensi/edit/-1");
		},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			me.items = [];
			let sessionStorage = window.sessionStorage;
			if (sessionStorage["filtroConsensi"]) {
				me.filtro = JSON.parse(sessionStorage["filtroConsensi"]);
			}
			me.filtro.page = me.currentPage;
			me.filtro.forPage = me.perPage;
			if (this.sezione != null) {
				me.filtro.sezione = this.sezione;
			}
			UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.$emit("afterLoadData");
			me.rows = response.data.data.recordsNumber;
			me.listKey++;
		},
		loadDataError(response) {
			let me = this;
			me.$emit("afterLoadData", response);
			me.$bvToast.toast("Errore durante il caricamento", {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
		},
		onClickPreview(item) {
			this.$refs.mdlPreviewConsensi.preview(item.id, item.dataModel);
		},
		onClickView(item) {
			this.$router.push("/consensi/view/" + item.id);
		},
		onClickEdit(item) {
			this.$router.push("/consensi/edit/" + item.id);
		},
		onRowSelected(item) {
			let obj = null;
			if (item.length > 0) {
				obj = item[0];
			}
			this.$emit("rowSelected", obj);
		},
		onClickAssociaProfili(consenso) {
			this.$refs.mdlConsensiProfiliListModalComponent.init(consenso);
		}
	},
};
</script>

<style>
.sa-alert-descrizione {
	font-style: italic;
}

.btn-table-action-section {
	gap: 2px;
}
</style>
